import type { User, UserRole } from '@/types';
import { resolveMvpAccountRole } from './accountRoles';

type SupabaseUserRow = Record<string, unknown>;

const text = (value: unknown): string => typeof value === 'string' ? value : '';
const nullableText = (value: unknown): string | null => text(value) || null;

export function mapAuthorityUser(row: SupabaseUserRow): User {
  const id = text(row.id);
  const email = text(row.email);
  const accountRole = resolveMvpAccountRole(nullableText(row.account_role));

  return {
    id,
    name: text(row.name),
    email,
    role: text(row.role) as UserRole,
    account_role: accountRole,
    platform_role: nullableText(row.platform_role) as User['platform_role'],
    workspace_role: nullableText(row.workspace_role) as User['workspace_role'],
    workspace_id: nullableText(row.workspace_id) ?? undefined,
    avatar: nullableText(row.avatar_url) ?? undefined,
    department: nullableText(row.department) ?? undefined,
    company: nullableText(row.company) ?? undefined,
    phone: nullableText(row.phone) ?? undefined,
    timezone: nullableText(row.timezone) ?? undefined,
    country: nullableText(row.country) ?? undefined,
    joinDate: new Date(text(row.created_at)),
    lastActive: new Date(text(row.last_active)),
    status: text(row.status) as User['status'],
  };
}